/**
 * Auth layout
 */

// React
import React from 'react';

// Material
import { Container } from '@mui/material';

// Components
import Footer from 'components/Footer';
import Loading from 'components/Loading';
import SnackNotify from 'components/SnackNotify';
import Header from 'components/Header';

// Common styles
import { ContentLayout, LayoutContainer } from 'styles';

// Utils
import { CombinedRouteProps } from 'utils/types';

const AuthLayout: React.FC<CombinedRouteProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  maxWidth,
  alignItems = 'start',
}) => {
  return (
    <LayoutContainer>
      {showHeader && <Header />}
      <SnackNotify />
      <Loading />
      <ContentLayout
        sx={{
          alignItems: alignItems,
        }}
      >
        <Container
          maxWidth={maxWidth ? maxWidth : false}
          sx={{
            paddingX: maxWidth ? { xs: '30px', sm: '30px', md: '0px' } : '0px !important',
          }}
        >
          {children}
        </Container>
      </ContentLayout>
      {showFooter && <Footer />}
    </LayoutContainer>
  );
};

export default AuthLayout;
